var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeviceBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1319",
    "data-name": "Group 1319",
    transform: "translate(0.054)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(-0.054)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M84.8-825.6v-1.6H81.6a1.54,1.54,0,0,1-1.13-.47A1.541,1.541,0,0,1,80-828.8v-9.6a1.541,1.541,0,0,1,.47-1.13A1.541,1.541,0,0,1,81.6-840H94.4a1.541,1.541,0,0,1,1.13.47A1.541,1.541,0,0,1,96-838.4v9.6a1.541,1.541,0,0,1-.47,1.13,1.54,1.54,0,0,1-1.13.47H91.2v1.6Zm-3.2-3.2H94.4v-9.6H81.6Zm0,0v0Z",
    transform: "translate(-72.129 848.5)",
    fill: "#1976d2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceBlue);
export default __webpack_public_path__ + "static/media/device_blue.03fd9f11cfb317ac83ccbfb907973d3c.svg";
export { ForwardRef as ReactComponent };